export const REFER_A_FRIEND = 'referafriend';
